// Copyright (c) 2025 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export enum BridgeFormInputName {
    DepositAmount = 'depositAmount',
    ReceivingAddress = 'receivingAddress',
    IsFromLayer1 = 'isFromLayer1',
    CoinType = 'coinType',
    IsDepositAddressManualInput = 'isDepositAddressManualInput',
}
